module.exports = __webpack_public_path__ + "media/buy-now/sample_box1-0b4321c2.png";